<template>
  <div>
    <div v-if="loading">loading...</div>
    <div v-else>
      <!-- header -->
      <div>
        <div style="display: flex; justify-content: space-between; align-items: top">
          <h1>{{ list.name }}</h1>
          <v-btn icon>
            <v-icon @click="showSheet = true" style="cursor: pointer">mdi-dots-vertical</v-icon>
          </v-btn>
        </div>
        <p>{{ list.description }}</p>
      </div>

      <!-- providers -->
      <div v-if="availableProviders.length" style="margin: 10px 0; display: flex; gap: 8px">
        <img
          v-for="provider in availableProviders"
          :key="provider.provider_id"
          :src="getProviderLogoUrl(provider)"
          @click="toggleProvider(provider.provider_id)"
          :style="{
            width: '50px',
            height: '50px',
            borderRadius: '8px',
            cursor: 'pointer',
            border: selectedProviders.includes(provider.provider_id) ? '3px solid #1976d2' : '3px solid transparent',
          }"
        />
      </div>

      <!-- items -->
      <div style="display: flex; flex-wrap: wrap; justify-content: space-between">
        <div v-for="item in filteredItems" :key="item">
          <MoviePoster :tmdb_id="item" />
        </div>
      </div>
    </div>

    <v-bottom-sheet v-model="showSheet">
      <v-card>
        <v-card-title>List details</v-card-title>
        <v-card-text>
          <v-text-field label="Nombre" v-model="list.name" @blur="saveList"></v-text-field>
          <v-textarea label="Descripción" v-model="list.description" @blur="saveList" rows="1" auto-grow></v-textarea>

          <v-btn v-if="!isInMyLists" block color="primary" @click="joinList">Unirse a esta lista</v-btn>

          <div style="display: flex; align-items: center; gap: 10px">
            <v-text-field v-if="false" :value="currentUrl" readonly outlined dense label="Enlace"></v-text-field>

            <v-btn @click="copyLink" depressed color="primary">
              <v-icon small class="mr-2">{{ linkCopied ? 'mdi-check' : 'mdi-content-copy' }}</v-icon>

              {{ linkCopied ? 'Link Copiado' : 'Copiar link' }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
import api from '@/assets/api'
import MoviePoster from './MoviePoster.vue'
import { getAllProviders, getProviderLogoUrl, movieHasProvider } from '@/assets/utils/providers'

export default {
  components: {
    MoviePoster,
  },
  props: {
    list_id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      list: {
        name: 'aaae',
        items: [],
      },
      loading: false,
      selectedProviders: [],
      movieDetails: [],
      showSheet: false,
      myLists: [],
      linkCopied: false,
    }
  },
  computed: {
    isInMyLists() {
      return this.myLists.includes(this.list_id)
    },
    currentUrl() {
      return window.location.href
    },
    availableProviders() {
      return getAllProviders(this.movieDetails, 'flatrate')
    },
    filteredItems() {
      if (this.selectedProviders.length === 0) return this.list.items
      return this.list.items.filter((tmdb_id) => {
        const movie = this.movieDetails.find((m) => m.tmdb_id === tmdb_id)
        if (!movie) return false
        return this.selectedProviders.some((providerId) => movieHasProvider(movie, providerId, 'flatrate'))
      })
    },
  },
  methods: {
    getProviderLogoUrl,
    toggleProvider(providerId) {
      const index = this.selectedProviders.indexOf(providerId)
      if (index > -1) {
        this.selectedProviders.splice(index, 1)
      } else {
        this.selectedProviders.push(providerId)
      }
    },
    copyLink() {
      navigator.clipboard.writeText(this.currentUrl)
      this.linkCopied = true
      setTimeout(() => {
        this.linkCopied = false
      }, 2000)
    },
    async saveList() {
      this.editingName = false
      await api.apiFetch(`/watchlistt/list?id=${this.list_id}`, {
        method: 'POST',
        body: JSON.stringify(this.list),
      })
    },
    async fetchListDetails() {
      this.loading = true
      let x = await api.apiFetch(`/watchlistt/list?id=${this.list_id}`)
      this.loading = false
      if (!x.ok) {
        console.error('Failed to fetch list details')
        return
      }
      const j = await x.json()
      this.list = { ...j }
      await this.fetchMovieDetails()
      await this.fetchMyLists()
    },
    async fetchMyLists() {
      const x = await api.apiFetch('/watchlistt/my-lists')
      if (x.ok) {
        const j = await x.json()
        this.myLists = j.lists || []
        await this.$nextTick()
        if (!this.myLists.includes(this.list_id)) {
          this.showSheet = true
        }
      }
    },
    async joinList() {
      const x = await api.apiFetch(`/watchlistt/join-list?list_id=${this.list_id}`, {
        method: 'POST',
        //body: JSON.stringify({}),
      })
      if (x.ok) {
        await this.fetchMyLists()
        this.showSheet = false
      }
    },
    async fetchMovieDetails() {
      const details = await Promise.all(
        this.list.items.map(async (tmdb_id) => {
          const x = await api.apiFetch(`/watchlistt/get-movie?tmdb_id=${tmdb_id}`)
          if (x.ok) return x.json()
          return null
        })
      )
      this.movieDetails = details.filter((d) => d !== null)
    },
  },
  mounted() {
    this.fetchListDetails()
  },
}
</script>

<style lang="scss" scoped></style>
